import React from "react"
import Chip from "../atoms/misc/Chip.atom"
import { getTeamColor } from "../../utils/teamAreas.utils"

export const TEAM_CHIP_TYPE = {
  ROUNDED: "rounded",
  SQUARE: "square",
}
const TeamChip = ({ teamTag, teamLabel, type = TEAM_CHIP_TYPE.ROUNDED }) => {
  return (
    <Chip
      className={`client-chip team-chip text-white ${type}`}
      template={
        <>
          <div
            className="bg-color"
            style={{ backgroundColor: `${getTeamColor(teamTag)}` }}
          ></div>
          <span style={{ fontSize: "12px", padding: "3.5px 7px" }}>
            {teamLabel || teamTag}
          </span>
        </>
      }
    />
  )
}

export default TeamChip
